import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import DatePicker from "react-datepicker";
import styles from './DateRangePicker.module.scss';
import "react-datepicker/dist/react-datepicker.css";
import SearchIcon from '@mui/icons-material/Search';
import moment from 'moment';
import {toast} from 'react-toastify';

const DateRangePicker = ({start, end, onCalendarChange}: any) => {
    const {t, i18n} = useTranslation();
    const [startDate, setStartDate] = useState<any>(new Date(start));
    const [endDate, setEndDate] = useState<any>(new Date(end));
    const handleDateChange = () => {
        if (moment(startDate).isValid() && moment(endDate).isValid() && moment(startDate).isSameOrBefore(moment(endDate))) {
            onCalendarChange(null, [moment(startDate).format(), moment(endDate).format()]);
        } else {
            toast.error(t('please check selected date range'));
        }
    };
    return (
        <div className={styles.container}>
            <div>
                <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                />
            </div>
            <div>-</div>
            <div>
                <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    minDate={startDate}
                    dateFormat="dd/MM/yyyy"
                />
            </div>
            <div className={styles.search} onClick={handleDateChange}>
                <SearchIcon />
            </div>
        </div>
    );
};

export default DateRangePicker;
